import { PerpVaultABI } from "./abis/PerpABI.js";
import { CodedEstateEvmInterfaceABI } from "./abis/CodedEstateEvmInterfaceABI.js";

// Mainnet chain id: 0x1AF4 (6900).
const EVM_CHAIN_ID = "0x1AF4";

export const NIBIRU_EVM_NETWORK_NAME = "Nibiru Mainnet";

export const NIBIRU_EVM_CHAIN = {
  chainId: EVM_CHAIN_ID,
  chainName: NIBIRU_EVM_NETWORK_NAME,
  nativeCurrency: {
    name: "NIBI",
    symbol: "NIBI",
    decimals: 18
  },
  rpcUrls: ["https://evm-rpc.nibiru.fi"],
  blockExplorerUrls: ["https://nibiscan.io/"]
};

// Perps vault (existing EVM perps integration)
export const PERP_VAULT_INTERFACE_ADDRESS = process.env.REACT_APP_NIBIRU_EVM_CONTRACT_ADDRESS;
export const PERP_VAULT_INTERFACE_ABI = PerpVaultABI;

// Rental gateway (CodedEstateEvmInterface on Nibiru EVM)
// Use REACT_APP_NIBIRU_EVM_RENTAL_CONTRACT_ADDRESS when Nibiru provides updated testnet deployment.
export const RENTAL_EVM_INTERFACE_ADDRESS =
  process.env.REACT_APP_NIBIRU_EVM_RENTAL_CONTRACT_ADDRESS ||
  "0x4ed6EcE884f374Db36aa447F972a139EeF810ea2";

export const RENTAL_EVM_INTERFACE_ABI = CodedEstateEvmInterfaceABI;

export const WASM_PRECOMPILE_ADDRESS = "0x0000000000000000000000000000000000000802";